<template>
    <Dialog :is-open="open" max-width="max-w-md">
        <div>
            <div class="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-slate-100">
                <RefreshCwIcon class="h-6 w-6 text-slate-600" aria-hidden="true" />
            </div>
            <div class="mt-3 text-center sm:mt-5">
                <h3 class="text-lg leading-6 font-medium text-slate-900">Reload Required</h3>
                <div class="mt-2">
                    <p class="text-sm text-slate-500">A new version is available. Please Reload your page.</p>
                </div>
            </div>
        </div>
        <div class="mt-5 p-1 sm:mt-6">
            <button
                type="button"
                class="inline-flex w-full justify-center rounded-md border border-transparent bg-slate-600 px-4 py-2 text-base font-medium text-white shadow-xs hover:bg-slate-700 focus:ring-2 focus:ring-slate-500 focus:ring-offset-2 focus:outline-hidden sm:text-sm"
                @click="reloadPage"
            >
                Reload now
            </button>
        </div>
    </Dialog>
</template>

<script setup>
import { RefreshCwIcon } from 'lucide-vue-next'

const open = ref(true)

function reloadPage() {
    location.reload()
}
</script>
